export function getGuideProgress(guideId) {
  try {
    const stored = localStorage.getItem(`guide_${guideId}_progress`);
    const progress = stored ? JSON.parse(stored) : { count: 0, steps: [] };
    return progress;
  } catch (error) {
    console.error('Error reading progress:', error);
    return { count: 0, steps: [] };
  }
}

export function setGuideProgress(guideId, count, steps = []) {
  try {
    localStorage.setItem(
      `guide_${guideId}_progress`, 
      JSON.stringify({ count, steps })
    );
  } catch (error) {
    console.error('Error saving progress:', error);
  }
}
